import http from "./core";

export const billingServer = {
  getInvoices(id) {
    return http.get(`api/portal/Billing/Invoices/${id}`);
  },
  getInvoice(invoiceId) {
    return http.get(`api/portal/Billing/Invoice/${invoiceId}`);
  }
};
